import { Component, Input, OnInit } from '@angular/core';
import { AuthSession } from 'app/interfaces/authsession.interface';
import { AuthWebService } from 'app/services/authweb.service';
import { SessionService } from 'app/services/session.service';
import { SignalrService } from 'app/services/signalr.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Component({
  selector: 'app-list-session',
  templateUrl: './list-session.component.html',
  styleUrls: ['./list-session.component.scss']
})
export class ListSessionComponent implements OnInit {
  @Input('ctrlData') ctrlData: any;
  flags = { flagSI: 1, flagPN: 1, flagPA: 1, flagST: 1, flagSS: 1, flagSE: 1 };
  ranks = { flagSI: 1, flagPN: 2, flagPA: 3, flagST: 4, flagSS: 5, flagSE: 6 };
  sortLabels = { flagSI: "SessionId", flagPN: "PCName", flagPA: "PCIPAddress", flagST: "Status", flagSS: "SessionStart", flagSE: "SessioneEnd" };
  sessions: any = [];
  criteria = "DateSubmitted";
  pcName: string;
  activePcName: string;
  isLoading: Boolean = false;
  keyword: any = {};
  message: string = 'Loading active sessions, please wait...';
  isEmpty: boolean = false;
  isListEmpty: boolean = false;
  pageSize: number = 10;
  count: number = 0;
  currentPage = 1;
  direction: boolean = false;
  selectedItems: any = [];
  rankCtrl: number = 6;
  processFlag:boolean=false;
  activesessionlist: any;
  aUser = environment.authWebApi.userData.User;

  constructor(public authWebService: AuthWebService, public signalrService: SignalrService,  private toastService: ToastNotificationService,
    private msg: ToastrService, private service: SessionService, public utility: UtilityServiceService
  ) { 

    signalrService.startConnection();
  }


  ngOnInit(): void {
    this.initKeyword();
    this.utility.page = 1;
    this.loadSessions(this.currentPage, this.pageSize);
    this.activesessionlist = this.signalrService.authSessionList;
    console.log(this.activesessionlist);
    this.signalrService.notifyAdmin();
    
  }

  initKeyword = () => {
    this.keyword = "All";
  }

  isSearchable = () => {
    return (this.pcName != null || this.selectedItems.length > 0);
  }

  setSearchKeywords = () => {
    this.keyword = (this.pcName != null) ? this.pcName : "All";
  }
onSearch = () => {
  if (!this.isSearchable()) {
    this.toastService.error("Please provide at least one filter value.", "Active Session Search");
    return;
  }
  this.setSearchKeywords();
  //console.log('Saved values = ', this.keyword);
  this.utility.page = 1;
  this.message = "Searching for active session(s), please wait...";
  this.loadSessions(this.utility.page, this.pageSize);
}

checkKey(event){
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode == 13) {
    this.onSearch();
    return;
  }
}

onReset = () => {
  this.selectedItems = [];
  this.pcName = null;
  this.utility.page = 1;
  this.initKeyword();
  this.isEmpty = false;
  ////console.log('Saved values = ', this.keyword);
  this.loadSessions(this.utility.page, this.pageSize);
}

onSort(rank: number) {
  this.direction = !this.direction;
  this.rankCtrl = rank;
  this.onExcuteSort(rank);
  this.loadSessions(this.utility.page, this.pageSize);
}

onResetFlags() {
  this.flags = { flagSI: 1, flagPN: 1, flagPA: 1, flagST: 1, flagSS: 1, flagSE: 1 };
}


onExcuteSort(rank: number) {
  this.onResetFlags();
  let sort = (this.direction) ? 3 : 2;
  this.criteria = null;
  switch (rank) {
    case this.ranks.flagSI: {
      this.criteria = this.sortLabels.flagSI;
      this.flags.flagSI = sort;
      break;
    }
    case this.ranks.flagPN: {
      this.criteria = this.sortLabels.flagPN;
      this.flags.flagPN = sort;
      break;
    }
    case this.ranks.flagPA: {
      this.criteria = this.sortLabels.flagPA;
      this.flags.flagPA = sort;
      break;
    }
    case this.ranks.flagST: {
      this.criteria = this.sortLabels.flagST;
      this.flags.flagST = sort;
      break;
    }
    case this.ranks.flagSS: {
      this.criteria = this.sortLabels.flagSS;
      this.flags.flagSS = sort;
      break;
    }
    default: {
      this.criteria = this.sortLabels.flagSE;
      this.flags.flagSE = sort;
      break;
    }
  }

}


loadSessions= (page: number = 1, pageSize: number = 10) =>{
  this.isLoading = true;
  this.authWebService.webrequest('GET','UserSession', 'GetAllActiveSessions',JSON.stringify({
    filter: this.keyword , PageNum: page, PageSize: pageSize, sort:this.rankCtrl, direction:this.direction
  })).then((data) => {
    this.sessions = data.Sessions;
    this.count = data.Count;
    if(this.count==0){
      this.isEmpty = true;
    }
    this.onExcuteSort(this.rankCtrl);
    this.isLoading = false;
    
  }, (error) => {
    console.log('Error occured: ' + error);
    this.isLoading = false;
    this.isEmpty = true;
  });
}

onNextOrPrevious(page: number = 1) {
  this.loadSessions(page, this.pageSize);
  this.currentPage = page;
  return page;
}

onChange = () => {
  this.loadSessions(this.utility.page = 1, this.pageSize);
}

getAllActiveSessions() {

  this.authWebService.webrequest('GET','UserSession', 'GetAllSession',null).then((data) => {
    this.sessions = data;
    console.log(data);
  }, (error) => {
    console.log('Error occured: ' + error);
    this.isLoading = false;
    this.isEmpty = true;
  });

}

TerminateSession(authsession : AuthSession)
{
  authsession.dateModified = new Date();
  authsession.userModifiedId = this.aUser.Id;
  this.service.releaseScanner(authsession.pcIpAddress).subscribe(data =>{
    console.log(data)
  })
  this.signalrService.stopClientSession(authsession);
}
openContent(evt, tabName) {

  var i, tabcontent, tablinks;
   tabcontent = document.getElementsByClassName("tabcontent");
   for (i = 0; i < tabcontent.length; i++) {
     tabcontent[i].style.display = "none";
   }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  } 
   document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

ngOnDestroy() {
  this.signalrService.hubConnection.off("notifyAdmin");
  console.log("stopped notification");
}

onSearchActiveSessions(){
  this.activesessionlist = this.activesessionlist.pipe(map((x:any) => x.filter(x => x.pcName.toLowerCase().includes(this.activePcName.toLowerCase()))));
  this.activesessionlist.subscribe(data =>{ 
    if(data.length == 0){
      this.isListEmpty=true;
    }else{
      this.isListEmpty=false;
    }
  });
}

onSearchReset(){
  this.activePcName = null;
  this.activesessionlist = this.signalrService.authSessionList;
  this.activesessionlist.subscribe(data =>{ 
    if(data.length == 0){
      this.isListEmpty=true;
    }else{
      this.isListEmpty=false;
    }
  });
}

}  